import {
  Input,
  InputProps,
  VStack,
  Flex,
  FormLabel,
  FormControl,
} from "@chakra-ui/react";
import { uniqueId } from "lodash";
import React, { useEffect } from "react";
import { StandardSelectOption } from "../../../../../selector/parts/SelectOption";
import { SingleSelector } from "../../../../../selector/SingleSelector";
import { AdjustTimeOperationEntry } from "../common";

export function TimeBulkEdit({
  operations,
  setOperations,
}: {
  operations: AdjustTimeOperationEntry[];
  setOperations: React.Dispatch<
    React.SetStateAction<AdjustTimeOperationEntry[]>
  >;
}): JSX.Element {
  useEffect(() => {
    setOperations([{ id: uniqueId(), type: "time" }]);
  }, [setOperations]);

  const options: StandardSelectOption<"forward" | "back">[] = [
    { value: "forward", data: { label: "Forward" } },
    { value: "back", data: { label: "Backward" } },
  ];

  return (
    <VStack alignItems="flex-start" w="full" gap={4}>
      {operations.map((operation) => (
        <Flex
          direction={{ base: "column", xs: "row" }}
          key={operation.id}
          w="full"
          wrap="wrap"
          gap={4}
        >
          <FormControl width="auto">
            <FormLabel>Direction</FormLabel>
            <SingleSelector
              options={options}
              value={operation.direction ?? "forward"}
              onChange={(value) =>
                setOperations(([op]) => [
                  {
                    ...op,
                    direction: value,
                  },
                ])
              }
              buttonProps={{
                width: { base: "full", xs: "auto" },
              }}
              popoverProps={{
                matchWidth: true,
              }}
            />
          </FormControl>
          <FormControl width="auto">
            <FormLabel>Hours</FormLabel>
            <TimeInput
              autoFocus
              value={operation.hours}
              onChange={(event) =>
                setOperations(([op]) => [
                  {
                    ...op,
                    hours: Number(event.target.value),
                  },
                ])
              }
            />
          </FormControl>
          <FormControl width="auto">
            <FormLabel>Minutes</FormLabel>
            <TimeInput
              value={operation.minutes}
              onChange={(event) =>
                setOperations(([op]) => [
                  {
                    ...op,
                    minutes: Number(event.target.value),
                  },
                ])
              }
            />
          </FormControl>
          <FormControl width="auto">
            <FormLabel>Seconds</FormLabel>
            <TimeInput
              value={operation.seconds}
              onChange={(event) =>
                setOperations(([op]) => [
                  {
                    ...op,
                    seconds: Number(event.target.value),
                  },
                ])
              }
            />
          </FormControl>
        </Flex>
      ))}
    </VStack>
  );
}

const TimeInput = (props: InputProps) => (
  <Input type="number" width={{ base: "full", xs: "5rem" }} {...props} />
);
